import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { celebrate } from "../../utility/celebrate";
import Utils from '../../utility/utility.js';
import { postApiCall } from "../../service/PostApiCall";
import { PROJECT_ADDTASK_HELPER, DAILY_CLOCK_IN_OUT, DAILY_CLOCK_VIEW, DAILY_CLOCK_OUT, DAILY_CLOCK_IN_EDIT, USER_MYLEAVE } from "../../service/apiUrl";
import Addtasks from "../../components/Addtasks";
import CustomModal from "../../components/CustomModal.js";
import ConfirmDialog from "../../components/ConfirmDialog.js";
import { STRING } from "../../constants/string.js";
import TaskTracker, { clockOutAt, nowSeconds, workedSeconds, WORKDAY_SECONDS } from "../../components/TaskTracker.js";
import StatCard from "../../components/StatCard.js";
import { Skeleton } from "../../components/Skeleton.js";
import LoadingButton from "../../components/LoadingButton.js";
import LeaveSummaryList from "./LeaveSummaryList.js";
import Collapsible from "../../components/Collapsible.js";
import GlowCursorEgg from "./GlowCursorEgg.js";
import WelcomeHeadline from "./WelcomeHeadline.js";
import {
  LEAVE_KINDS,
  leaveDays,
  leaveKind,
  leaveStart,
  leaveStatusTab,
} from "../leaves/leaveTone";
import moment from "moment";

const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const Developer = (props) => {

  const [isLessWork, setIsLessWork] = useState(false);

  const [isTaskHasError, setIsTaskHasError] = useState(false);
  const [isSatWorking, setIsSatWorking] = useState({ value:"", yes: false, no: false, date: null });

  const [viewData, setViewData] = useState({});
  const [myLeaves, setMyLeaves] = useState([]);
  /* Whether the two fetches behind this page have come back at all. `viewData`
     starts as `{}` and every figure derived from it falls back to 0 / "--:--",
     so without these the page painted a complete, wrong day (00:00:00 worked,
     0 tasks, a green "Clock In" for someone already clocked in) and then
     corrected itself. They flip on both settle paths, so a failed request
     shows the empty state rather than shimmering forever. */
  const [clockLoaded, setClockLoaded] = useState(false);
  const [leavesLoaded, setLeavesLoaded] = useState(false);
  const [leaveSummary, setLeaveSummary] = useState(null);
  const [leaveListOpen, setLeaveListOpen] = useState(false);
  const [isView, setIsView] = useState(false);
  const [taskContainerCount, setTaskContainerCount] = useState([]);
  const [taskErrors, setTaskErrors] = useState([]);
  const [projectDetails, setProjectDetails] = useState({});
  const [show, setShow] = useState(false);
  const [deleteConfirmationShow, setDeleteConfirmationShow] = useState({ status: false, value: null });

  const [isBreak, setIsBreak] = useState(false);
  const [reason, setReason] = useState({ value: "", error: false });
  const [breakErrors, setBreakErrors] = useState({});
  const [breakTime, setBreakTime] = useState({
    hours: '',
    minutes: '',
  });


  const [tasks, setTasks] = useState([]);
  const [isUpdating, setUpdating] = useState(false);
  const [dropdowns, setDropdowns] = useState({
    projectsList: [],
    projectTrackersList: [],
    billingTypes: [],
    isOffline: [],
    clickupAccounts: [],
    errors: [],
  });

  const signdata = useSelector((state) => state.signinReducers);

  // play the birthday animation once per visit, for whoever's birthday it is
  const hasCelebrated = useRef(false);
  useEffect(() => {
    if (!hasCelebrated.current && viewData?.birthdays?.length) {
      hasCelebrated.current = true;
      celebrate();
    }
  }, [viewData?.birthdays]);

  const uid = signdata.data ? Number(signdata.data.id) : null;
  /**
   * The id of today's entry. dailyTasks is empty until a task has been saved,
   * so reading dt_id only from there meant a day that was clocked in without
   * tasks looked like it had no entry at all - tasks could then never be
   * attached to it. The tracker and break rows carry the same dt_id.
   */
  const dayEntryId = viewData?.dailyTasks?.[0]?.dt_id
    || viewData?.tracker?.[0]?.dt_id
    || viewData?.break?.dt_id;

  useEffect(() => {

    if (uid != null) {
      postApiCall({ uid: uid }, signdata?.data?.access_token, PROJECT_ADDTASK_HELPER)
        .then((result) => {
          setProjectDetails(result)

        })
        .catch((error) => {
          console.error('USER_HELPER', error);
        })

      getClockData();

      /* the leave tile below. Same endpoint views/leaves/MyLeaves.js reads.
         It paginates (10 by default), so ask for the whole history the way
         MyLeaves does - without a page size the tile only ever counted the
         ten newest requests, and an older approved leave read as not taken. */
      postApiCall({ page: 1, pageSize: 1000 }, signdata?.data?.access_token, USER_MYLEAVE)
        .then((result) => {
          setMyLeaves(result?.leaves ?? []);
          /* the paid-leave ledger (LeaveBalance::forUser on the backend):
             `balance` is the days still available, `credited` what has
             accrued so far this year, `unpaid` what was taken beyond it. */
          setLeaveSummary(result?.leave_summary ?? null);
        })
        .catch((error) => {
          console.error('MY_LEAVE', error);
        })
        .finally(() => setLeavesLoaded(true))
    }

  }, []);

  const getClockData = () => {
    return postApiCall({ date: Utils.momentDate(new Date(), STRING.CLOCK_FORMATED_DATE) }, signdata?.data?.access_token, DAILY_CLOCK_VIEW)
      .then((result) => {
        setViewData(result)
      })
      .catch((error) => {

        console.error('CLOCK_VIEW', error);
        if (error.data.message != undefined) {
          Utils.toast("error", error.data.message);
        }

      })
      .finally(() => setClockLoaded(true))
  }

  useEffect(() => {
    if (!viewData?.break?.no_break_reason && viewData?.break?.break) {
      let breakTime = viewData?.break?.break?.split(":");
      setBreakTime({
        hours: breakTime[0],
        minutes: breakTime[1]
      })
    } else if (viewData?.break?.no_break_reason) {
      setIsBreak(true)
      setReason({ error: false, value: viewData?.break?.no_break_reason })
    }
    let totalWorkingHours = 0;
    viewData?.dailyTasks?.map(value => {
      totalWorkingHours += parseInt(value.working_hrs)
    })

    if (viewData?.dailyTasks?.length && totalWorkingHours < 9) {
      // setViewData({...viewData,isLessWork:true})
      setIsLessWork(true);
    } else {
      setIsLessWork(false);
    }

  }, [viewData])

  useEffect(() => {
    setDropdowns({ ...dropdowns, projectsList: projectDetails?.projects ?? [], clickupAccounts: projectDetails?.clickupAccounts ?? [] })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectDetails?.clickupAccounts, projectDetails?.projects])

  /**
   * If the project is re-selected or changed, then refresh or reset the billing dropdowns
   * 
   * @param {*} obj 
   * @returns 
   */
  const resetDropDowns = obj => {

    obj['billing_id'] = obj['billing_type'] = ''; //obj['task_description'] = '';
    return obj;

  }

  const handleChange = (e, idx) => {
    e.preventDefault()

    // drop the inline error for the field being edited. Changing the project
    // resets the billing dropdowns, so their errors go with it.
    const edited = e.target.name;
    const cleared = edited === 'project_id'
      ? ['project_id', 'billing_type', 'billing_id']
      : [edited];
    setTaskErrors(prev => prev.map((err, i) => {
      if (i !== idx || !err) return err;
      const next = { ...err };
      cleared.forEach(field => delete next[field]);
      return next;
    }));

    const updatedTasks = tasks.map((obj, i) => {
      if (idx == i) {

        obj[e.target.name] = e.target.value;
        //If the project is re-selected or changed, then refresh or reset the billing dropdowns
        if (e.target.name == 'project_id') {
          resetDropDowns(obj);
        }
        if (e.target.name === 'project_id') {
          const selectedProject = projectDetails?.projects?.filter(value => {
            return e.target.value == value?.id
          })
          var { projectTrackersList, billingTypes, isOffline } = dropdowns;

          if (selectedProject?.length) {


            projectTrackersList[i] = selectedProject?.[0]?.trackers;

            billingTypes[i] = projectDetails?.billing_type?.filter(value => {
              return value.value == selectedProject?.[0]?.billing_type;
            })

            isOffline[i] = selectedProject?.[0]?.is_offline;

          } else {
            projectTrackersList[i] = []
            billingTypes[i] = []
            isOffline[i] = ""
          }

          setDropdowns({ ...dropdowns, projectTrackersList: projectTrackersList, billingTypes: billingTypes, isOffline: isOffline });
        }
        if (e.target.name === "working_hrs" || e.target.name === "project_id" || e.target.name === "billing_type") {
          var { errors } = dropdowns;

          if (tasks?.[idx]?.project_id && tasks?.[idx]?.billing_type && tasks?.[idx]?.billing_type != "0") {
            const project = dropdowns?.projectsList?.filter(val => val.id == tasks?.[idx]?.project_id)?.[0];
            if ((project?.estimated_hour - project?.activity?.online) < tasks?.[idx]?.working_hrs) {
              errors[i] = { ...errors[i], working_hrs: true };
              setIsTaskHasError(true);
            } else {
              errors[i] = { ...errors[i], working_hrs: false };
              setIsTaskHasError(false);
            }
          } else if (tasks?.[idx]?.project_id && tasks?.[idx]?.billing_type && tasks?.[idx]?.billing_type == '0') {
            errors[i] = { ...errors[i], working_hrs: false };
            setIsTaskHasError(false);
          }
          setDropdowns({ ...dropdowns, errors: errors });

        }
      }
      return obj;
    });

    setTasks(updatedTasks);

  }

  const updateNewTaskContainer = () => {
    setTaskContainerCount([...taskContainerCount, 0]);
    if (tasks?.length) {
      setTasks([...tasks, { project_id: 0, billing_id: 0, billing_type: '', working_hrs: '', task_description: '' }]);
    } else {
      setTasks([{ project_id: 0, billing_id: 0, billing_type: '', working_hrs: '', task_description: '' }]);
    }

  }

  const closeTaskContainer = idx => {

    setDeleteConfirmationShow({ value: idx, status: true })

  }

  const deleteTaskContainer = () => {
    if (deleteConfirmationShow.value > -1 && deleteConfirmationShow.status) {
      taskContainerCount.splice(deleteConfirmationShow.value, 1);
      tasks.splice(deleteConfirmationShow.value, 1);
      setTaskErrors(prev => prev.filter((_, i) => i !== deleteConfirmationShow.value));
      setTaskContainerCount(taskContainerCount);
      setTasks(tasks);
      setUpdating(!isUpdating);
      setDeleteConfirmationShow({ value: null, status: false })
    }
  }

  const againClockIn = (e) => {
    e?.preventDefault();
    const payLoad = {
      uid: uid,
      tasks: [],
      againClockIn: true,
    }
    // console.log('payLoad',payLoad);
    // return;

    return postApiCall(payLoad, signdata?.data?.access_token, DAILY_CLOCK_IN_OUT)
      .then((result) => {
        getClockData()
      })
      .catch((error) => {

        console.error('USER_HELPER', error);
        if (error.data.message != undefined) {
          Utils.toast("error", error.data.message);
        }
        throw error;

      })
  }

  const SaveDailyClockInOut = async () => {

    if (validation() && !isLessWork && !isTaskHasError) {
      const payLoad = {
        uid: uid,
        tasks: tasks
      }
    //   console.log('payLoad 2',payLoad);
    // return;

      return postApiCall(payLoad, signdata?.data?.access_token, DAILY_CLOCK_IN_OUT)
        .then((result) => {
          setTasks([])
          setTaskContainerCount([]);
          setTaskErrors([]);
          setIsView(false)
          getClockData()
        })
        .catch((error) => {

          console.error('USER_HELPER', error);
          if (error.data.message != undefined) {
            Utils.toast("error", error.data.message);
          }
          throw error;

        })
    } else if (isLessWork) {
      const payLoad = {
        uid: uid,
        dt_id: dayEntryId,
        tasks: tasks
      }
      return postApiCall(payLoad, signdata?.data?.access_token, DAILY_CLOCK_IN_EDIT)
        .then((result) => {
          setTasks([])
          setTaskContainerCount([]);
          setTaskErrors([]);
          // setIsView(false)
          getClockData()
        })
        .catch((error) => {

          console.error('USER_HELPER', error);
          if (error.data.message != undefined) {
            Utils.toast("error", error.data.message);
          }
          throw error;

        })
    }

    return false
  }

  /**
   * A dropdown that was never touched still holds the 0 it was created with,
   * and Utils.isEmpty(0) is false, so an unpicked project used to pass.
   */
  const isUnset = value => Utils.isEmpty(value) || value === 0 || value === '0';

  /**
   * Each field is checked on its own so the card reports every problem at
   * once, inline under the field it belongs to, rather than one alert at a
   * time. Returns whether all of the cards are valid.
   */
  const validation = () => {
    const errors = (tasks ?? []).map(value => {
      const e = {};
      if (isUnset(value?.project_id)) {
        e.project_id = STRING.ENTER_PROJECT;
      }
      if (Utils.isEmpty(value?.billing_type)) {
        e.billing_type = STRING.ENTER_BILLING_STATUS;
      }
      // Billing Id is optional - it deliberately has no rule here
      if (Utils.isEmpty(value?.working_hrs)) {
        e.working_hrs = STRING.ENTER_WORKING_HOURS;
      }
      if (Utils.isEmpty(value?.task_description)) {
        e.task_description = STRING.ENTER_TASK_DESCRIPTION;
      }
      return e;
    });

    setTaskErrors(errors);
    return errors.every(e => Object.keys(e).length === 0);
  }

  const clockOut = (e) => {
    e?.preventDefault();
    setShow(true);
  }

  const editEntery = () => {
    if (viewData?.dailyTasks?.length) {
      if (!isView) {
        setTasks(viewData?.dailyTasks)
        setTaskContainerCount(new Array(viewData?.dailyTasks?.length).fill(0));

        viewData?.dailyTasks?.map((obj, i) => {
          const selectedProject = projectDetails?.projects?.filter(value => {
            return obj.project_id == value?.id
          })
          var { projectTrackersList, billingTypes, isOffline } = dropdowns;

          if (selectedProject?.length) {

            projectTrackersList[i] = selectedProject?.[0]?.trackers;

            billingTypes[i] = projectDetails?.billing_type?.filter(value => {
              return value.value == selectedProject?.[0]?.billing_type;
            })

            isOffline[i] = selectedProject?.[0]?.is_offline;

          } else {
            projectTrackersList[i] = []
            billingTypes[i] = []
            isOffline[i] = ""
          }

          setDropdowns({ ...dropdowns, projectTrackersList: projectTrackersList, billingTypes: billingTypes, isOffline: isOffline });
        })

        // setIsView(true)
      } else {
        setTasks([])
        setTaskContainerCount([]);
        // setIsView(false)
      }

    }
  }

  const viewTasks = () => {
    if (viewData?.dailyTasks?.length) {
      if (!isView) {
        setTasks(viewData?.dailyTasks)
        setTaskContainerCount(new Array(viewData?.dailyTasks?.length).fill(0));

        viewData?.dailyTasks?.map((obj, i) => {
          const selectedProject = projectDetails?.projects?.filter(value => {
            return obj.project_id == value?.id
          })
          var { projectTrackersList, billingTypes, isOffline } = dropdowns;

          if (selectedProject?.length) {

            projectTrackersList[i] = selectedProject?.[0]?.trackers;

            billingTypes[i] = projectDetails?.billing_type?.filter(value => {
              return value.value == selectedProject?.[0]?.billing_type;
            })

            isOffline[i] = selectedProject?.[0]?.is_offline;

          } else {
            projectTrackersList[i] = []
            billingTypes[i] = []
            isOffline[i] = ""
          }

          setDropdowns({ ...dropdowns, projectTrackersList: projectTrackersList, billingTypes: billingTypes, isOffline: isOffline });
        })

        setIsView(true)
      } else {
        setTasks([])
        setTaskContainerCount([]);
        setIsView(false)
      }

    }
  }

  /**
   * Closing the day from the break dialog.
   *
   * This used to post { uid, tasks } to DAILY_CLOCK_IN_EDIT with dt_id
   * commented out, which is what produced `Undefined array key "dt_id"`:
   * dailyTasks is empty until an entry exists, so there was nothing to edit
   * and no id to send. The tasks are saved through the same endpoint
   * SaveDailyClockInOut uses, and the break details the dialog collects - the
   * break length, the no-break reason and the Saturday answer, all of which
   * were being discarded - close the day through DAILY_CLOCK_OUT, the way
   * HrClockIn does it.
   */
  const addBreak = () => {

    const errors = {};

    if (Utils.momentDate(new Date(), 'dddd') == 'Friday' && !viewData?.isSatWorking &&
        isSatWorking.yes === false && isSatWorking.no === false) {
      errors.sat = STRING.SELECT_SATURDAY_OPTION;
    }

    // either a break was taken (hours / minutes), or "No Break" is ticked and
    // a reason of at least 45 characters explains why it was not
    if (!((isBreak && reason?.value?.trim()?.length > 44) || breakTime?.minutes)) {
      errors.reason = isBreak ? STRING.ENTER_BREAK_REASON : STRING.SELECT_BREAK_TIME;
    }

    setBreakErrors(errors);
    setReason({ ...reason, error: !!errors.reason });
    if (Object.keys(errors).length) return false;

    const token = signdata?.data?.access_token;
    const dtId = dayEntryId;

    const clockOutPayLoad = {
      "break": `${(breakTime?.hours && !Utils.isEmpty(breakTime?.hours)) ? breakTime?.hours : '00'}:${(breakTime?.minutes && !Utils.isEmpty(breakTime?.minutes)) ? breakTime?.minutes : '00'}`,
      "no_break_reason": reason?.value,
      "sat_working": isSatWorking?.yes ? isSatWorking?.date : '',
    }

    // DAILY_CLOCK_IN_OUT is the clock IN - posting to it here answers
    // "Already clocked-in", so it must not be used on the way out. Tasks are
    // saved only when there are cards being filled in; in view mode they are
    // the day's saved tasks being displayed, so re-posting them is pointless.
    const saveTasks = (dtId && tasks?.length && !isView)
      ? postApiCall({ uid: uid, dt_id: dtId, tasks: tasks }, token, DAILY_CLOCK_IN_EDIT)
      : Promise.resolve();

    return saveTasks
      .then(() => postApiCall(clockOutPayLoad, token, DAILY_CLOCK_OUT))
      .then((result) => {
        setTasks([])
        setTaskContainerCount([]);
        setTaskErrors([]);
        setBreakErrors({});
        setShow(false)
        // postApiCall resolves with response.data.data, so the API's own
        // message is not available here - state it ourselves
        Utils.toast("success", STRING.CLOCK_OUT_SUCCESS);
        getClockData()
      })
      .catch((error) => {

        console.error('clock out', error);
        if (error?.data?.message != undefined) {
          Utils.toast("error", error.data.message);
        }
        throw error;

      })
  }

  const hasActiveTracker = viewData?.tracker?.some(val => !val.end_time);

  /* The clock-out tile counts down to the end of the day, so it needs a clock
     of its own while a session is open; a minute is as fine as it reads. */
  const [now, setNow] = useState(nowSeconds);
  useEffect(() => {
    if (!hasActiveTracker) return undefined;
    setNow(nowSeconds());
    const id = setInterval(() => setNow(nowSeconds()), 30000);
    return () => clearInterval(id);
  }, [hasActiveTracker]);
  const hasTodayTime = viewData?.todayTime && viewData?.todayTime > 0;
  const hasTasks = viewData?.dailyTasks?.length > 0;

  /* ---- the stat row -------------------------------------------------------
     The clock card above already states today's hours and this week's, one
     of them ticking, so tiles repeating those two figures told the user
     nothing they had not read one line earlier. The row is the three things
     the clock card cannot answer: leave taken, tasks logged, and when the
     day started and when it can end.

     The figure is the number of approved requests in the current calendar
     year - one request is one leave taken, whatever its type or how many
     days it spans - and the footer carries the pending ones. Under it, what
     that figure is made of: each kind of leave, how many requests of it, and
     the days they cost. A day count used to be impossible here because the
     `type` this endpoint returns ("Half day Leave (Sep 17,2026)(Thursday)")
     never equalled the bare "Full day" / "Half day" the comparison expected,
     so it read 0 days for five real leaves; `leaveKind` in views/leaves
     normalises the wording and `leaveDays` turns it into a number, which is
     also what the leave listing filters on - one definition, three screens.

     No percentage or trend anywhere: the payload has no earlier period to
     compare against, and an arrow would claim one. */
  const leaveYear = moment().year();

  /* By statusKey, not the literal: the endpoint's casing and spelling of a
     status are not stable (see views/leaves/leaveTone.js). */
  const approvedLeaves = (myLeaves ?? []).filter(leave => {
    if (leaveStatusTab(leave)?.value !== "approved") return false;
    const start = leaveStart(leave);
    return start.isValid() && start.year() === leaveYear;
  });

  /* Short leaves stay off the tile's figures - they are hours, not leave
     days, and are capped at one a month anyway. They still show in the
     "View more" breakdown and list, which read `approvedLeaves`/`myLeaves`. */
  const isShortLeave = leave => leaveKind(leave?.type) === "Short leave";
  const countedLeaves = approvedLeaves.filter(leave => !isShortLeave(leave));

  const pendingLeaveCount = (myLeaves ?? []).filter(
    leave => leaveStatusTab(leave)?.value === "pending" && !isShortLeave(leave)).length;

  const takenLeaveDays = countedLeaves.reduce(
    (total, leave) => total + leaveDays(leave), 0);

  /* Grouped from the data rather than counted against a fixed list, so the
     parts always add up to the figure above them: the three known kinds are
     seeded (a kind not taken this year is a row reading 0, not a gap), and a
     kind nobody here has seen still gets its own row instead of vanishing. */
  const leavesByKind = (() => {
    const groups = new Map(LEAVE_KINDS.map(kind => [kind, []]));
    approvedLeaves.forEach(leave => {
      const kind = leaveKind(leave?.type);
      if (!groups.has(kind)) groups.set(kind, []);
      groups.get(kind).push(leave);
    });
    return [...groups];
  })();

  const leaveBreakdown = leavesByKind.map(([kind, leaves]) => {
    const days = leaves.reduce((total, leave) => total + leaveDays(leave), 0);
    return {
      label: kind,
      value: leaves.length,
      /* A short leave is hours, not days, so it has no day figure to show -
         an em dash keeps the column, where "0 days" would claim the leave
         cost nothing. */
      sub: days > 0
        ? days + (days === 1 ? " day" : " days")
        : leaves.length && kind === "Short leave" ? "\u2014" : null,
    };
  });

  const taskCount = viewData?.dailyTasks?.length ?? 0;
  const taskHours = (viewData?.dailyTasks ?? []).reduce(
    (total, task) => total + (parseInt(task?.working_hrs) || 0), 0);
  const taskProjectCount = new Set(
    (viewData?.dailyTasks ?? []).map(task => String(task?.project_id))).size;

  /* end_time is null on the session that is still open, and Number(null) is a
     finite 0, so the ends have to be filtered on the value and not on
     Number.isFinite alone. */
  const sessionStarts = (viewData?.tracker ?? [])
    .map(row => Number(row?.start_time)).filter(value => value > 0);
  const sessionEnds = (viewData?.tracker ?? [])
    .map(row => Number(row?.end_time)).filter(value => value > 0);
  const firstClockIn = sessionStarts.length ? Math.min(...sessionStarts) : null;
  const lastClockOut = sessionEnds.length ? Math.max(...sessionEnds) : null;
  const clockTime = timestamp =>
    Utils.momentDateFromTimestamp(STRING.PROJECT_TIME_FORMAT, timestamp);
  /* "07:02 PM" at figure size does not fit half a tile, so the meridiem is
     set small after the digits */
  const clockFigure = timestamp => {
    const [digits, meridiem] = clockTime(timestamp).split(" ");
    return (
      <>
        {digits}
        <span className="stat-card-unit">{meridiem}</span>
      </>
    );
  };
  const hoursAndMinutes = seconds => {
    const minutes = Math.ceil(Math.max(0, seconds) / 60);
    const hours = Math.floor(minutes / 60);
    return (hours ? hours + "h " : "") + (minutes % 60) + "m";
  };

  /* Nine hours of work, the break not counted. While a session is open that
     is a time still to come; once the day is closed it is a verdict on the
     day that was. */
  const workedToday = workedSeconds(viewData?.tracker, viewData?.break, now);
  const finishAt = clockOutAt(viewData?.tracker, viewData?.break, now);
  const workLeft = WORKDAY_SECONDS - workedToday;


  /**
   * Bottom action of the daily task form. Tasks are saved by both the clock in
   * and the clock out path, so the required fields are checked first and any
   * problem is reported before the entry is submitted.
   */
  const submitTasks = (e) => {
    if (!tasks?.length) {
      Utils.toast('error', STRING.ADD_TASK_FIRST);
      return false;
    }
    if (!validation()) {
      return false;
    }
    if (hasActiveTracker) {
      // this only opens the break dialog - nothing is written yet
      clockOut(e);
      return false;
    }
    return SaveDailyClockInOut();
  }
  return (
    <>
      <div className={props?.data?.transtion === true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body dashboard developer-dashboard">

          <div className="page-head">
            <div className="page-eyebrow">My Day</div>
            <WelcomeHeadline />
            <p className="page-sub">
              Your hours, tasks and announcements for {Utils.getCurrentDate()}.
            </p>
          </div>

          <div className="row">
            {viewData?.announcements?.map((data, idx) => {
              return (<div className="col-md-12" key={idx}>
                <div className="alert alert-warning shadow" role="alert">
                  <h4 className="alert-heading">
                    <i className="fa fa-bullhorn" aria-hidden="true"></i>{" "}{data.title}</h4>
                  <div dangerouslySetInnerHTML={{ __html: data.description }} />
                </div>
              </div>);
            })}
            {viewData?.birthdays?.map((data, idx) => {
              return (<div className="col-md-12" key={idx}>
                <div className="alert alert-info shadow" role="alert">
                  <h4 className="alert-heading">
                    <i className="fa fa-bullhorn" aria-hidden="true"></i>{` Today is ${data.first_name} ${data.last_name}'s Birthday!` }</h4>
                  {data.wish ? <p className="birthday-wish">“{data.wish}”</p> : null}
                </div>
              </div>);
            })}
            {viewData?.alreadyUsedBillingId?.map((data, idx) => {
              return (<div className="col-md-12" key={idx}>
                <div className="alert alert-danger shadow" role="alert">
                  <span className="text-bold">{data?.map(val => val.name)?.join(', ')}</span> is also using <span className="text-bold">{data?.[0]?.BillingId}</span> ID. Please verify before using it.
                </div>
              </div>);
            })}
            {/* {
              true ?
                <div className="col-md-12">
                  <Tabs className="">
                    <TabList>
                      <Tab> <FontAwesomeIcon className="p-2 br-50" style={{
                        color:'#C9695E',
                        backgroundColor:'#FDE9E9'
                      }} icon={faBirthdayCake} /> <span className="pb-2" >Birthdays</span> </Tab>
                      <Tab> <FontAwesomeIcon className="p-2 br-50" style={{
                        color:'#FDE9E9',
                        backgroundColor:'#EFFCE8'
                      }} icon={faBirthdayCake} /> <span className="pb-2" >Work Anniversary</span></Tab>
                    </TabList>
                    <TabPanel></TabPanel>
                    <TabPanel></TabPanel>
                  </Tabs>
                </div>
                : ""
            } */}
            <div className="col-md-12">
              <div className="task-report-description">
                <h3>Add tasks for {Utils.getCurrentDate()}</h3>
              </div>
            </div>
            <div className="col-md-12">
              <div className="mt-3 card-input">
                <div className="week-data">
                  <div className="calender-icon icon"><i style={{ width: '20px' }} className="fa fa-calendar-check-o"></i></div>
                  <div className="week-calculated">
                    <p className="text-small">You have worked</p>
                    <div className="text-center hours">
                      <p className="text-big">
                        {clockLoaded ? (
                          <span className="reveal-in">{Utils.getHoursFromSeconds(viewData?.weekTime)}</span>
                        ) : (
                          <Skeleton
                            className="sk-inline"
                            width="4.5ch"
                            height=".7em"
                          />
                        )}
                      </p>
                      <p className="text-small">HH:MM:SS</p>
                    </div>
                    <p className="text-small">This week</p>
                  </div>
                </div>
                <div className="today-data">
                  <div className="clock-icon icon"><i style={{ width: '20px' }} className="fa fa-clock-o"></i></div>
                  <div className="today-calculated">
                    <p className="text-small">You have worked</p>
                    <div className="text-center hours">
                      {
                        !clockLoaded ?
                          <p className="text-big">
                            <Skeleton
                              className="sk-inline"
                              width="4.5ch"
                              height=".7em"
                            />
                          </p>
                          :
                        viewData?.tracker?.filter(val => !val.end_time)?.length === 0 ?
                          <p className="text-big reveal-in">
                            {viewData?.todayTime && viewData?.todayTime > 0 ? Utils.getHoursFromSeconds(viewData?.todayTime) : Utils.getHoursFromSeconds(0)}
                          </p>
                          :
                          <TaskTracker startTime={viewData?.tracker} breakTime={viewData?.break} />
                      }
                      <p className="text-small">HH:MM:SS</p>
                    </div>
                    <p className="text-small">Today</p>
                  </div>
                </div>
                {
             <div className="controls btn-multiple">
             <div className="btn-group-vertical">
           
               {
                 /* Which button belongs here is a fact about today's entry.
                    Guessing it before the entry arrives showed a green "Clock
                    In" to someone who was already clocked in - one mis-click
                    away from a second session. */
                 !clockLoaded ? (
                   <>
                     <Skeleton width={120} height={38} radius="var(--app-radius-sm)" />
                     <Skeleton
                       width={120}
                       height={38}
                       radius="var(--app-radius-sm)"
                       style={{ marginTop: ".5rem" }}
                     />
                   </>
                 ) :
                 (hasActiveTracker || hasTodayTime) && !isLessWork ? (
                   <>
                     {
                 
                       hasTodayTime && !hasActiveTracker ? (
                         <LoadingButton
                           className="button btn btn-danger"
                           successLabel="Clocked in"
                           onAction={() => againClockIn()}
                         >
                           Clock In
                         </LoadingButton>
                       ) : (
                         <button
                           className="button btn btn-danger"
                           onClick={(e) => {
                             if (isLessWork) {
                               editEntery()
                             } else if (hasTasks) {
                               // today's tasks are already saved, so there is
                               // nothing to fill in - close the day directly
                               clockOut(e)
                             } else {
                               updateNewTaskContainer()
                             }
                           }}
                         >
                           Clock Out
                         </button>
                       )
                     }
                     {
                       hasTasks && (
                         <button
                           className="button btn btn-info mt-2"
                           onClick={viewTasks}
                         >
                           {isView ? 'Hide' : 'View'} Tasks
                         </button>
                       )
                     }
                   </>
                 ) : (
                   <>
                     <LoadingButton
                       className="button btn btn-success"
                       successLabel="Clocked in"
                       onAction={() => againClockIn()}
                     >
                       Clock In
                     </LoadingButton>
                     <button
                       className="button btn btn-info mt-2"
                       onClick={() => {
                         if (isLessWork) {
                           editEntery()
                         } else {
                           updateNewTaskContainer()
                         }
                       }}
                     >
                       Add Tasks
                     </button>
                     {
                       hasTasks && (
                         <button
                           className="button btn btn-info mt-2"
                           onClick={viewTasks}
                         >
                           {isView ? 'Hide' : 'View'} Tasks
                         </button>
                       )
                     }
                   </>
                 )
               }
           
             </div>
           </div>
                }
              </div>
            </div>
          </div>

          <hr className="dashboard-divider" />

          <div className="row row-deck row-cards">
            <div className="col-sm-6 col-lg-4">
              {/* Taken, pending and remaining side by side: the three things an
                  employee asks about their leave. Remaining is the paid-leave
                  balance the backend keeps, not anything derived here - a
                  missing ledger shows a dash, never a made-up 0. */}
              <StatCard
                label={"Leaves in " + leaveYear}
                figures={[
                  {
                    label: "Taken",
                    value: countedLeaves.length,
                    sub: takenLeaveDays + (takenLeaveDays === 1 ? " day" : " days"),
                  },
                  {
                    label: "Pending",
                    value: pendingLeaveCount,
                    tone: "attention",
                    sub: pendingLeaveCount === 1 ? "request" : "requests",
                  },
                  {
                    label: "Remaining",
                    value: leaveSummary ? leaveSummary.balance : "\u2014",
                    sub: leaveSummary
                      ? "of " + leaveSummary.credited + " credited"
                      : "not available",
                  },
                ]}
                note={
                  Number(leaveSummary?.unpaid) > 0
                    ? leaveSummary.unpaid +
                      (Number(leaveSummary.unpaid) === 1 ? " day" : " days") +
                      " unpaid this year"
                    : null
                }
                action={{
                  label: leaveListOpen ? "Show less" : "View more",
                  expanded: leaveListOpen,
                  controls: "leave-summary-list",
                  id: "leave-summary-trigger",
                  onClick: () => setLeaveListOpen(open => !open),
                }}
                loading={!leavesLoaded}
              />
            </div>

            <div className="col-sm-6 col-lg-4">
              <StatCard
                label="Tasks Logged Today"
                value={taskCount}
                badge={hasTasks ? null : "Nothing logged"}
                badgeTone={hasTasks ? null : "attention"}
                note={
                  !hasTasks
                    ? "No task entry for today yet"
                    : taskHours + (taskHours === 1 ? " hour" : " hours") +
                      " of work described"
                }
                sub={
                  taskProjectCount
                    ? "Across " +
                      taskProjectCount +
                      (taskProjectCount === 1 ? " project" : " projects")
                    : "Add today's tasks to close the day"
                }
                loading={!clockLoaded}
              />
            </div>

            <div className="col-sm-6 col-lg-4">
              <StatCard
                label="Today's Clock"
                badge={
                  hasActiveTracker
                    ? "Clocked in"
                    : firstClockIn
                    ? "Clocked out"
                    : "Not started"
                }
                badgeTone={
                  hasActiveTracker ? "success" : firstClockIn ? null : "attention"
                }
                figures={[
                  {
                    label: "Clock in",
                    value: firstClockIn ? clockFigure(firstClockIn) : "--:--",
                    sub:
                      sessionStarts.length > 1
                        ? sessionStarts.length + " sessions"
                        : null,
                  },
                  hasActiveTracker
                    ? {
                        label: "Clock out at",
                        value: finishAt ? clockFigure(finishAt) : "--:--",
                        sub: workLeft > 0 ? "+ your break" : "Day complete",
                      }
                    : {
                        label: "Clock out",
                        value: lastClockOut ? clockFigure(lastClockOut) : "--:--",
                        sub: lastClockOut
                          ? workLeft > 0
                            ? hoursAndMinutes(workLeft) + " short"
                            : "Full day"
                          : null,
                      },
                ]}
                note={
                  hasActiveTracker
                    ? workLeft > 0
                      ? hoursAndMinutes(workLeft) + " of work left today"
                      : "9 hours done, you can clock out"
                    : firstClockIn
                    ? "Worked " + hoursAndMinutes(workedToday) + " today"
                    : "No clock-in yet today"
                }
                sub={Utils.momentDate(new Date(), STRING.DASHBOARD_DATE)}
                loading={!clockLoaded}
              />
            </div>
          </div>

          {/* The list behind the leave tile's "View more", full width under
              the row: opened inside the tile it would stretch its two
              neighbours (row-deck keeps a row one height) into empty boxes.
              The leaves are already here from page load, so the list is
              rendered up front and "View more" only springs it open. */}
          <Collapsible
            id="leave-summary-list"
            triggerId="leave-summary-trigger"
            open={leaveListOpen}
          >
            <LeaveSummaryList
              leaves={myLeaves}
              year={leaveYear}
              breakdown={leaveBreakdown}
            />
          </Collapsible>

          <div className="row mt-5">
            <div className="col-md-12">
              <div className="tasks-wrappers">
                {
                  // <RenderNewTaskContainer />
                  tasks?.map((val, i) => {
                    return (<Addtasks
                      on_close_container={() => closeTaskContainer(i)}
                      index={i}
                      key={i}
                      isView={isView}
                      fieldErrors={taskErrors?.[i]}
                      dropdowns={dropdowns}
                      on_change={e => handleChange(e, i)}
                      task={tasks[i]}
                    />);
                  })
                }
              </div>
              {
                taskContainerCount.length > 0 && !isView ?
                  <div className="form-group text-right mt-3 mvb-3">
                    <button onClick={() => updateNewTaskContainer()} type="button" className="button btn btn-info">Add More Tasks</button>
                    {
                      hasActiveTracker ?
                        <LoadingButton disabled={isTaskHasError} onAction={() => submitTasks()}
                          successLabel="Clocked out" className="button btn btn-danger ml-2">Clock Out</LoadingButton>
                        :
                        <LoadingButton disabled={isTaskHasError} onAction={() => submitTasks()}
                          successLabel="Clocked in" className="button btn btn-success ml-2">Clock In</LoadingButton>
                    }
                  </div>
                  :
                  <></>
              }
            </div>
          </div>

          {/* easter egg: a glow trail below the 76% line (GlowCursorEgg.js) */}
          <GlowCursorEgg />
        </div>
      </div>
      <ConfirmDialog
        isShow={deleteConfirmationShow.status}
        onHide={() => { setDeleteConfirmationShow({ ...deleteConfirmationShow, status: false }) }}
        title="Delete this task?"
        description="The task and its logged hours are removed from today's timesheet. This cannot be undone."
        confirmLabel="Delete"
        successLabel="Deleted"
        tone="danger"
        onConfirm={deleteTaskContainer}
      />
      <CustomModal
        isShow={show}
        onHide={() => { setShow(false) }}
        heading="Add break information"
        footer={
          <>
            <button type="button" onClick={() => { setShow(false) }} className="app-dialog-btn app-dialog-btn-ghost">Cancel</button>
            <LoadingButton name="submit" id="addbreak" onAction={addBreak} successLabel="Break added" className="app-dialog-btn app-dialog-btn-primary">Add break</LoadingButton>
          </>
        }
      >
        <div className="row">
          <div className="col-md-12">
            <div className="mb-0">
              <label>All Lunch break inside office is also treated as break.</label>
              {
                !isBreak ? <div className="col-md-12">
                  <div className="row ">
                    <div className="form-group mr-3">
                      <label htmlFor="hours" className="text-bold">Hours</label>
                      <select className="form-control w-7" id="hours" value={breakTime?.hours} onChange={(e) => {
                        setBreakTime({ ...breakTime, hours: e.target.value })
                        setBreakErrors(prev => ({ ...prev, reason: undefined }))
                      }}>
                        <option value={''}>Please select Hours</option>
                        {
                          new Array(5).fill('').map((val, idx) => {
                            const value = (idx + 1).toString().padStart(2, '0');
                            return <option key={idx} value={value}>{value}</option>
                          })
                        }
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="minutes" className="text-bold">Minutes</label>
                      <select className="form-control w-7" id="minutes" value={breakTime?.minutes} onChange={(e) => {
                        setBreakTime({ ...breakTime, minutes: e.target.value })
                        setBreakErrors(prev => ({ ...prev, reason: undefined }))
                      }}>
                        <option value={''}>Please select Minutes</option>
                        {
                          new Array(3).fill('').map((val, idx) => {
                            const value = (45 + idx * 5).toString().padStart(2, '0');
                            return <option key={idx} value={value}>{value}</option>
                          })
                        }
                      </select>
                    </div>
                  </div>
                  <FieldError msg={breakErrors?.reason} />
                </div>
                  : ''
              }
              <div className="col-md-12">
                <div className="row ">
                  <div className="form-check">
                    <input checked={isBreak} className="form-check-input" type="checkbox" value="" id="break" onChange={(e) => {
                      setIsBreak(e.target.checked)
                      setBreakErrors(prev => ({ ...prev, reason: undefined }))
                    }} />
                    <label className="form-check-label" htmlFor="break">
                      No Break
                    </label>
                  </div>
                </div>
              </div>
              {
                isBreak ? <div className="col-md-12">
                  <div className="row ">
                    <div className="form-group w-75">
                      <label className="text-bold" htmlFor="reason">Reason <span className="text-danger"> (Minimum 45 characters)</span></label>
                      <textarea value={reason?.value} onChange={(e) => {
                        setReason({ ...reason, value: e.target.value, error: false })
                        if (e.target.value?.trim()?.length > 44) {
                          setBreakErrors(prev => ({ ...prev, reason: undefined }))
                        }
                      }} rows="3" id="brkcomments" name="brkcomments" className={`form-control ${breakErrors?.reason ? 'is-invalid' : ''}`}> </textarea>
                      <div id="characterLeft">Characters: {reason?.value?.trim()?.length ?? 0}</div>
                      <FieldError msg={breakErrors?.reason} />
                    </div>
                  </div>
                </div> : ''
              }
              {
               Utils.momentDate(new Date(), 'dddd') == 'Friday' && !viewData?.isSatWorking ?
                  <div className="row mx-0 mt-3">
                    {/* <div className="col-md-12"> */}
                    Are you working this Saturday?
                    <div className="form-check ml-2">
                      <input className="form-check-input" name="isSatWorking" type="checkbox" onChange={(e) => {
                        setIsSatWorking({
                          ...isSatWorking,
                          yes:e.target.checked,
                          no: e.target.checked === true &&  isSatWorking.no === true ? false : isSatWorking.no,
                          date : Utils.getLastSaturday()
                        })
                        setBreakErrors(prev => ({ ...prev, sat: undefined }))
                      }} value="yes" id="yes" checked={isSatWorking.yes} />
                      <label className="form-check-label" htmlFor="yes">
                        Yes
                      </label>
                    </div>
                    <div className="form-check ml-2">
                      <input className="form-check-input" name="isSatWorking" type="checkbox" onChange={(e) => {
                        setIsSatWorking({
                          ...isSatWorking,
                          yes:e.target.checked === true &&  isSatWorking.yes === true ? false : isSatWorking.yes ,
                          no: e.target.checked,
                          date : null
                        })
                        setBreakErrors(prev => ({ ...prev, sat: undefined }))
                      }} value="no" id="no" checked={isSatWorking.no} />
                      <label className="form-check-label" htmlFor="no">
                        No
                      </label>
                    </div>
                    {/* </div> */}
                    <FieldError msg={breakErrors?.sat} />
                  </div>
                  :
                  <div></div>
              }
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default Developer;
